import { render, staticRenderFns } from "./CobranzaView.vue?vue&type=template&id=5b9a42b7&scoped=true"
import script from "./CobranzaView.vue?vue&type=script&lang=js"
export * from "./CobranzaView.vue?vue&type=script&lang=js"
import style0 from "./CobranzaView.vue?vue&type=style&index=0&id=5b9a42b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a42b7",
  null
  
)

export default component.exports